<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
definePage({
  meta: {
    title: "Dashboard",
  },
});
</script>
